<template>
  <div>
    <AlgoliaSelectedFiltersWatcher />
    <v-menu offset-y :close-on-content-click="closeOnContentClick">
      <template v-slot:activator="{ on }">
        <v-btn
          outlined
          v-on="on"
          class="mr-5"
        >
          <v-icon>local_printshop</v-icon>
          {{$t('buttons.print')}}
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          @click="item.callback"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import { algoliaService, palletService } from '@/_services'
import { mapState } from 'vuex'
import AlgoliaSelectedFiltersWatcher from '@/components/general/AlgoliaSelectedFiltersWatcher'

export default {
  name: 'ExportOrders',
  components: {
    AlgoliaSelectedFiltersWatcher
  },
  props: {},
  data () {
    return {
      orders: [],
      items: [
        { title: this.$i18n.t('general.print_as_pdf'), callback: () => this.printPdf() },
        { title: this.$i18n.t('general.print_as_csv'), callback: () => this.printCsv() }
      ],
      closeOnContentClick: false,
      buttonClicked: null,
      allVolumes: [],
      allWeights: [],
      volumeAverage: null,
      weightAverage: null
    }
  },
  computed: {
    ...mapState(['route', 'generalApp'])
  },
  methods: {
    takeIndex (index) {
      this.buttonClicked = index
    },
    async fetchOrders () {
      let orders = await algoliaService.getHitsForOrderExport('prod_orders', 1000, this.generalApp.allSelectedFilters)
      this.orders = orders.hits
      // orders.then((result) => {
      //   this.orders = result.hits
      //   return result
      // })
    },
    async printPdf () {
      await this.fetchOrders()
      console.log(this.orders.length)
      let Pdf = jsPDF
      // pdf for orders
      // for the head it uses the mocked shipment (shipment in props) from ShipmentDetail component
      // TO DO after ShipmentDetail fetches shipment using ID change mock data here too
      let date = new Date()

      let doc = new Pdf('landscape')

      let body = []

      for (let i = 0; i < this.orders.length; i++) {
        if (this.orders[i].comment.startsWith('MANUAL')) {
          let orderRef = this.orders[i].seller.order_ref
          let seller = this.orders[i].seller.name
          let buyer = this.orders[i].buyer.name
          let customer_ref = this.orders[i].buyer.org_ref !== '0' ? this.orders[i].buyer.org_ref : ''
          let packages = this.orders[i].packages
          let comment = this.orders[i].comment
          let volume = this.$options.filters.roundValue(this.orders[i].volume, 2)
          let weight = this.$options.filters.roundValue(this.orders[i].weight, 2)

          body.push([orderRef, seller, buyer, customer_ref, packages, comment, volume, weight])
        }
      }

      doc.autoTable({
        head: [
          [
            { content: this.$i18n.t('menu.orders'), colSpan: 10, styles: { halign: 'center', fillColor: [238, 238, 238] } }
          ],
          [
            this.$i18n.t('print_files.order_ref'),
            this.$i18n.t('orders.seller'),
            this.$i18n.t('orders.buyer'),
            this.$i18n.t('orders.customer_ref'),
            this.$i18n.t('shipments.packages'),
            this.$i18n.t('print_files.comment'),
            this.$i18n.t('fleet.volume') + ' [CBM]',
            this.$i18n.t('orders.weight') + ' [KG]'
          ]
        ],
        body: body,
        styles: { fontSize: 7, textColor: [33, 33, 33] },
        theme: 'grid',
        headStyles: { fillColor: [255, 255, 255], lineWidth: 0.1 },
        columnStyles: { 3: { halign: 'right' }, 5: { halign: 'right' }, 6: { halign: 'right' } }
      })

      // creates the page count on the document
      let pageCount = doc.internal.getNumberOfPages()
      for (let i = 0; i < pageCount; i++) {
        doc.setPage(i)
        doc.text(280, 208, doc.internal.getCurrentPageInfo().pageNumber + '/' + pageCount)
      }

      doc.save(this.$i18n.t('menu.orders') + '.pdf')
    },
    async printCsv () {
      await this.fetchOrders()
      // csv file for orders
      let csvContent = 'data:text/csv;charset=utf-8,'
      let rows = []
      rows.push([
        this.$i18n.t('shipments.order_ref'),
        this.$i18n.t('orders.seller'),
        this.$i18n.t('orders.buyer'),
        this.$i18n.t('orders.customer_ref'),
        this.$i18n.t('orders.packages'),
        this.$i18n.t('print_files.comment'),
        this.$i18n.t('shipments.volume'),
        this.$i18n.t('orders.weight_2')
      ])
      for (let i = 0; i < this.orders.length; i++) {
        let orderRef = this.orders[i].seller.order_ref
        let seller = this.orders[i].seller.name
        let buyer = this.orders[i].buyer.name
        let customer_ref = this.orders[i].buyer.org_ref !== '0' ? this.orders[i].buyer.org_ref : ''
        let packages = this.orders[i].packages
        let comment = this.orders[i].comment
        let volume = this.orders[i].volume
        let weight = this.orders[i].weight

        rows.push([orderRef, seller, buyer, customer_ref, packages, comment, volume, weight])
      }
      rows.forEach(function (rowArray) {
        let row = rowArray.join(';')
        csvContent += row + '\r\n'
      })
      let encodedUri = encodeURI(csvContent)
      let link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute('download', this.$i18n.t('orders.orders') + '.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

</script>

<style>
v-overflow-btn {
  width: 100px;
}
</style>
